// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Constants from "expo-constants";
import { Config } from "../dtos/config";

// please refer to the README for more info on environment variable handling
export const appConfig: Config = {
  production: Constants.manifest.extra.production,
  baseUrl: Constants.manifest.extra.baseUrl,
  env: "whitelabel-api",
  tenant: Constants.manifest.extra.tenant,
  tenantDomain: Constants.manifest.extra.tenantDomain,
  primaryColour: Constants.manifest.extra.primaryColour,
  warningColor: Constants.manifest.extra.warningColor,
  alertColor: Constants.manifest?.extra.alertColor,
  successColor: Constants.manifest?.extra.successColor,
  dashboardBackground: Constants.manifest.extra.dashboardBackground,
  testMode: Constants.manifest.extra.testMode === "true",
  environment: Constants.manifest.extra.environment,
  firebase: {
    apiKey: Constants.manifest.extra.apiKey,
    authDomain: Constants.manifest.extra.authDomain,
    projectId: Constants.manifest.extra.projectId,
    storageBucket: Constants.manifest.extra.storageBucket,
    messagingSenderId: Constants.manifest.extra.messagingSenderId,
    appId: Constants.manifest.extra.appId,
  },
  features: {
    signupRequiresContributionLimit:
      Constants.manifest.extra.signupRequiresContributionLimit === "true",
    signupRequiresCustomerReference:
      Constants.manifest.extra.signupRequiresCustomerReference === "true",
    signupRequiresWebApp:
      Constants.manifest.extra.signupRequiresWebApp === "true",
  },
  saveUserCredsSecretPass: Constants.manifest.extra.saveUserCredsSecretPass,
  redirectUrl: Constants.manifest.extra.redirectUrl,
};
